<template>
  <div>
    <div class="form-group" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select v-bind:id="idDelInput" v-model="idDelModelo" class="form-control" @change="cambiarDatos($event)">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} un Juicio</option>
        <option v-else="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" value="value">{{enumeraciones.tiposDeSelect.Todos.Nombre}} los Juicios</option>
        <option v-for="Juicio in Juicios" :value="Juicio.JuicioId">{{Juicio.Nombre}}</option>
      </select>
    </div>
  </div>
</template>
<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import catalogos from '@/../static/js/catalogos'
  import comun from '@/../static/js/comun'
  import api from '@/../static/js/api'
  import {mapActions} from 'vuex'
  import axios from 'axios'

  export default
  {
    data(){
      return {
        enumeraciones,
        comun,
        Juicios:[],
        idDelModelo: -1
      }
    },//Data
    props: {
      prefijo: Number,
      parametros: Object,
      tipo: {
        Id: Number,
        Nombre: String
      },
      idDelInput: String,
      valorDefinido: Number,
      materia: ''
    },//Props
    mounted() {
       if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;

      const parametros = {
        llave: this.idDelInput,
        valor: this.idDelModelo
      }
      this.$store.dispatch("A_PJ_Catalogo_Establecer042Juicio_TemisCivil", { llave: this.idDelInput, valor: this.idDelModelo });
    },
    methods: {
    RegresaIdMateria(){
      if(this.materia == 'Contencioso')
        return 1;
      if(this.materia == 'Civil')
        return 2;
      if(this.materia == 'Mercantil')
        return 3;
      if(this.materia == 'Familiar')
        return 4;
      if(this.materia == 'Laboral')
        return 13;
    },
    CargarCatalogoDeJuicios(){
      let peticion = {
        EsPrueba: comun.EsPrueba,
        MateriaId: this.RegresaIdMateria()
      }
      axios.post(api.conexion + api.PJ.catalogos.C042JuiciosTemisCivil, peticion)
          .then(respuesta => {
            if (respuesta.data.SiHayError) {
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {
              this.Juicios = respuesta.data.Juicios;
              //Seleccionar el primer juicio n_n
              this.idDelModelo = this.Juicios[0].JuicioId;
              this.cambiaJuicioInicial();
              return respuesta.data.Juicios;
            }
          }).catch(e => {
           console.log("No Hay Respuesta del Servidor" + e);
         });
    },//CargarCatalogoDeJuicios
    cambiarDatos: function (event) {
        this.idDelModelo = event.target.value;
        this.$store.dispatch("A_PJ_Catalogo_Establecer042Juicio_TemisCivil", { llave: this.idDelInput, valor: event.target.value});
        this.$emit("valorParaElPadre", event);
      },
    cambiaJuicioInicial: function(){
        this.$store.dispatch("A_PJ_Catalogo_Establecer042Juicio_TemisCivil", { llave: this.idDelInput, valor: this.idDelModelo});
        this.$emit("valorParaElPadre", this.idDelModelo);
      }
    },//Methods
    created() {
      this.CargarCatalogoDeJuicios();
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/PJ/Catalogos/042JuiciosTemisCivil.vue